/*
 * Judge.me renders its preview badge as stars plus a review count ("1 avis"). The average is present in the
 * markup as a data attribute but never displayed, so this prepends it: "5/5 - 1 avis".
 *
 * The badge is built by Judge.me's own script after this one runs, and is rebuilt on some events, so the DOM
 * is watched rather than polled.
 */
(function () {
  if (window.judgemeAverageRatingBound) {
    return;
  }

  window.judgemeAverageRatingBound = true;

  var BADGE = '.jdgm-prev-badge[data-average-rating]';
  var TEXT = '.jdgm-prev-badge__text';
  var ORIGINAL = 'data-jdgm-original-text';
  var SEPARATOR = ' - ';
  var SCALE = 5;

  function formatAverage(raw) {
    var value = parseFloat(raw);

    if (!isFinite(value) || value <= 0) {
      return null;
    }

    // Judge.me stores "5.00"; show "5" and "4,6" rather than "5.00" and "4.60".
    try {
      return value.toLocaleString(document.documentElement.lang || undefined, { maximumFractionDigits: 1 });
    } catch (error) {
      return String(Math.round(value * 10) / 10);
    }
  }

  function decorate(badge) {
    if (!(parseInt(badge.getAttribute('data-number-of-reviews'), 10) > 0)) {
      return;
    }

    var text = badge.querySelector(TEXT);

    if (!text || !text.textContent.trim()) {
      return;
    }

    var average = formatAverage(badge.getAttribute('data-average-rating'));

    if (!average) {
      return;
    }

    // Judge.me's own wording is remembered once, so re-running never stacks prefixes and a changed
    // average replaces the previous one instead of being prepended to it.
    if (!text.hasAttribute(ORIGINAL)) {
      text.setAttribute(ORIGINAL, text.textContent.trim());
    }

    var desired = average + '/' + SCALE + SEPARATOR + text.getAttribute(ORIGINAL);

    if (text.textContent !== desired) {
      text.textContent = desired;
    }
  }

  function sweep() {
    document.querySelectorAll(BADGE).forEach(decorate);
  }

  var scheduled = null;

  // setTimeout rather than requestAnimationFrame: rAF is paused in a background tab, and Judge.me rewrites
  // the badge text shortly after rendering it, so the pass that puts the average back would never run.
  function schedule() {
    if (scheduled !== null) {
      return;
    }

    scheduled = setTimeout(function () {
      scheduled = null;
      sweep();
    }, 0);
  }

  sweep();

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
